import React from 'react';
import PropTypes from 'prop-types';

import get from 'utils/get';
import cx from 'classnames';
import slugify from 'utils/slugify';
import flattenMediaData from 'utils/flattenMediaData';
import contentfulImgUtil from 'utils/contentfulImgUtil';
import imageModel from 'models/imageModel';
import marked from 'marked';

import { Image, Audio } from 'components/base';

const BlockAudio = ({ block }) => {
  const fields = get(block, 'fields', {});
  const title = get(fields, 'title', '');
  const image = flattenMediaData(get(fields, 'image', {}));
  const audio = flattenMediaData(get(fields, 'audio', {}));
  const caption = get(fields, 'caption', '');
  const audioWaveColor = slugify(get(fields, 'audioWaveColor', 'Dark'));
  const showBlockTitle = get(fields, 'showBlockTitle', false);

  return (
    <div
      className={cx(
        'BlockAudio relative py4 px2_5 relative flex flex-col items-center justify-center',
        { guideline: showBlockTitle }
      )}
    >
      {showBlockTitle ? (
        <p className="block-title absolute r0 t0">{title}</p>
      ) : null}
      <div className="flex flex-col items-center justify-center w100">
        <Image
          alt={get(image, 'description', '')}
          src={contentfulImgUtil(get(image, 'url', ''), '489')}
          className="BlockAudio__image"
        />
        <div className="w100 absolute flex justify-center pt4">
          <Audio
            className="BlockAudio__audio-container flex flex-row"
            src={audio.url}
            color={audioWaveColor}
          />
        </div>
      </div>
      {!!caption && (
        <div
          className={cx(
            'BlockAudio__caption caption markdown-text mt4 text-center'
          )}
          dangerouslySetInnerHTML={{
            __html: marked(caption)
          }}
        />
      )}
    </div>
  );
};

BlockAudio.propTypes = {
  block: PropTypes.shape({
    fields: PropTypes.shape({
      image: imageModel.propTypes,
      audio: imageModel.propTypes,
      caption: PropTypes.string,
      audioWaveColor: PropTypes.string,
      title: PropTypes.string,
      showBlockTitle: PropTypes.bool
    })
  })
};

BlockAudio.defaultProps = {
  block: {
    fields: {
      image: imageModel.default,
      audio: imageModel.default,
      caption: '',
      audioWaveColor: 'Dark',
      title: '',
      showBlockTitle: false
    }
  }
};

export default BlockAudio;
